import Component from './DeviceOperators.vue';

export default Component;
